import styled from 'styled-components'
import { colors } from 'client/styles'
import { InputWrapper } from '../InputLine/styles'

const loadingBlock = () => `
  opacity: 0.5;
  pointer: events;
`

export const RangeWrapper = styled.div`
  margin-block: 27px 30px;
  margin-inline: 10px;
  ${props => props.isLoading && loadingBlock()}
  .rc-slider-rail {
    height: 2px;
    background-color: ${colors.grey4};
  }
  .rc-slider-track {
    background-color: ${colors.magenta};
    height: 2px;
  }
  .rc-slider-handle {
    width: 24px;
    height: 24px;
    border: solid 2px ${colors.magenta};
    margin-block-start: -11px;
  }
  .rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {
    border-color: ${colors.magenta};
    box-shadow: 0 0 0 5px ${colors.magenta2};
  }
`

export const InputSection = styled.div`
  display: flex;
  justify-content: space-between;
  margin-block-end: 10px;
  ${props => props.isLoading && loadingBlock()}
  ${InputWrapper} {
    max-width: calc(50% - 12px);
  }
`
